import 'firebase/firestore';
import chunk from 'lodash.chunk';
import { useMemo } from 'react';
import { ButtonLink } from '../components/Button';
import { Highscore } from '../components/Highscore';
import { PlayAgainButton } from '../components/PlayAgainButton';
import { View } from '../components/View';
import { useHighscores } from '../hooks/useHighscores';

type HighscoreWithPosition = { position: number } & Game.Highscore;

export function HighscoreView() {
  const { data = [] } = useHighscores();
  const columns: HighscoreWithPosition[][] = useMemo(() => {
    const withPosition: HighscoreWithPosition[] = data.map((highscore, i) => ({
      ...highscore,
      position: i + 1,
    }));
    return chunk(withPosition, 4);
  }, [data]);

  return (
    <View title="Topplistan">
      <div className="mt-14 flex flex-row space-x-10 mb-14">
        {columns.map((column, columnIndex) => (
          <div key={columnIndex} className="space-y-4">
            {column.map((highscore) => (
              <Highscore key={highscore.id} {...highscore} />
            ))}
          </div>
        ))}
      </div>
      <PlayAgainButton />

      <p className="text-lg text-gray-900 mb-10">
        Är du intresserad av att veta mer om vilka produkter vi erbjuder?
      </p>

      <ButtonLink href="https://ultrabutiken.se" target="blank">
        Besök <b>ultrabutiken.se</b>
      </ButtonLink>
    </View>
  );
}
